var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"market-info-box"},[_c('MarketInfoBoxTitle',{on:{"mouseover":function($event){_vm.displayPopup = true}}}),_vm._v(" "),(_vm.displayPopup)?_c('MarketInfoBoxPopup'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }